<div class="formulario-contenido-menu">
  <div class="formulario-header">
    <h2>Agendar Nueva Visita</h2>
    <p class="subtitulo">Complete los detalles para programar una nueva visita (modo offline).</p>
    <ion-button fill="clear" size="small" class="btn-cerrar" (click)="cerrar()">
      <ion-icon slot="icon-only" name="close-outline"></ion-icon>
    </ion-button>
  </div>

  <div class="formulario-content">
    <ion-note *ngIf="faltanCatalogosLocales" color="warning" class="aviso-catalogos-offline" role="status">
      No hay usuarios o tipos de visita en este dispositivo. Conéctese y use «Sincronizar Ruta del Día» en el dashboard
      para poder agendar.
    </ion-note>
    <form [formGroup]="form" class="formulario-form">
      <!-- 1. Usuario INDAP: misma estructura (búsqueda + select) -->
      <div class="form-item-usuario-indap">
        <ion-label position="stacked">Usuario INDAP <span class="required">*</span></ion-label>
        <div class="usuario-indap-container">
          <ion-searchbar [(ngModel)]="terminoBusqueda" [ngModelOptions]="{ standalone: true }"
            (ionInput)="onBuscarChange()" (ionClear)="onBuscarChange()" placeholder="Buscar ..." debounce="350"
            class="searchbar-productor">
          </ion-searchbar>
          <div class="select-container">
            <ion-select formControlName="id_productor" placeholder="Seleccione un usuario" interface="popover"
              [interfaceOptions]="{ cssClass: 'select-popover select-popover-large' }">
              <ion-select-option *ngFor="let p of (productoresFiltrados || [])" [value]="p.id_productor">
                {{ p.nombre }} {{ p.primer_apellido }} {{ p.segundo_apellido }}
              </ion-select-option>
            </ion-select>
          </div>
          <p *ngIf="productores.length > 0 && productoresFiltrados.length === 0" class="productor-busqueda-sin-resultados"
            role="status" aria-live="polite">
            No se encontraron usuarios con ese criterio. Pruebe con otro término o borre la búsqueda para ver el listado
            completo.
          </p>
        </div>
      </div>

      <!-- 2. Lugar de la Visita -->
      <ion-item class="form-item" lines="none">
        <ion-label position="stacked">Lugar de la Visita <span class="required">*</span></ion-label>
        <ion-input formControlName="lugar" placeholder="Ej: Fundo El Encanto, Parcela 2"></ion-input>
      </ion-item>

      <!-- 3. Fecha y Hora Programada (misma UI: datetime-button + popover) -->
      <div class="fecha-hora-container">
        <ion-item class="form-item" lines="none">
          <ion-label position="stacked">Fecha Programada <span class="required">*</span></ion-label>
          <ion-datetime-button datetime="offline-datetime-fecha"></ion-datetime-button>
          <ion-popover [keepContentsMounted]="true">
            <ng-template>
              <ion-datetime id="offline-datetime-fecha" [value]="fechaProgramadaISO || undefined"
                (ionChange)="onFechaChange($event)" locale="es-CL" presentation="date"
                [formatOptions]="{ date: { day: '2-digit', month: '2-digit', year: 'numeric' } }">
              </ion-datetime>
            </ng-template>
          </ion-popover>
        </ion-item>

        <ion-item class="form-item" lines="none">
          <ion-label position="stacked">Hora Programada</ion-label>
          <ion-datetime-button datetime="offline-datetime-hora"></ion-datetime-button>
          <ion-popover [keepContentsMounted]="true">
            <ng-template>
              <ion-datetime id="offline-datetime-hora" [value]="horaProgramada || undefined" (ionChange)="onHoraChange($event)"
                locale="en-US" presentation="time"
                [formatOptions]="{ time: { hour: '2-digit', minute: '2-digit', hour12: true } }">
              </ion-datetime>
            </ng-template>
          </ion-popover>
        </ion-item>
      </div>

      <!-- Descripción -->
      <ion-item class="form-item" lines="none">
        <ion-label position="stacked">Descripción <span class="required">*</span></ion-label>
        <ion-textarea formControlName="descripcion" placeholder="Describa el objetivo o alcance de la visita" rows="3">
        </ion-textarea>
      </ion-item>

      <!-- 5. Tipo de Visita y Objetivo(s) -->
      <div class="tipo-objetivo-container">
        <ion-item class="form-item" lines="none">
          <ion-label position="stacked">Tipo de Visita <span class="required">*</span></ion-label>
          <ion-select formControlName="id_tipo_visita" placeholder="Seleccione un tipo" interface="popover"
            [interfaceOptions]="{ cssClass: 'select-popover select-popover-medium' }">
            <ion-select-option *ngFor="let t of tiposVisita" [value]="t.id_tipo_visita">
              {{ t.descripcion }}
            </ion-select-option>
          </ion-select>
        </ion-item>
        <div class="form-item form-item-objetivos">
          <ion-label position="stacked">Temas</ion-label>
          <app-selector-objetivos-visita-registro
            formControlName="id_objetivo_visita"
            [objetivosVisita]="objetivosVisita">
          </app-selector-objetivos-visita-registro>
        </div>
      </div>

      <ion-item class="form-item form-item-checkbox" lines="none">
        <ion-checkbox formControlName="bolsa_visita" labelPlacement="end">
          Bolsa de Visita
        </ion-checkbox>
      </ion-item>

      <!-- 9. Es Emergencia (igual que original: select + info popover) -->
      <div class="toggle-emergencia-wrapper">
        <ion-item class="form-item form-item-emergencia" lines="none">
          <ion-label position="stacked">Es Emergencia <span class="required">*</span></ion-label>
          <ion-select formControlName="es_contingencia" placeholder="Seleccione" interface="popover"
            [interfaceOptions]="{ cssClass: 'select-popover select-popover-medium' }"
            helperText="Marque si la visita se debe a una emergencia o imprevisto.">
            <ion-select-option [value]="null">Seleccione</ion-select-option>
            <ion-select-option [value]="true">Sí</ion-select-option>
            <ion-select-option [value]="false">No</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-button [id]="idEmergenciaInfo" fill="clear" size="small" class="boton-informacion" aria-label="Información">
          <ion-icon name="information-circle-outline" slot="icon-only"></ion-icon>
        </ion-button>
        <ion-popover [trigger]="idEmergenciaInfo" [triggerAction]="'click'" reference="trigger" [side]="'top'"
          [alignment]="'center'">
          <ng-template>
            <div class="popover-informacion">
              <p>Visita asociada a emergencia agrícola o catástrofe declarada por la autoridad competente, o definida por la Dirección Nacional de INDAP conforme a la Ley N°18.910. No contempla urgencias propias del manejo habitual del predio.</p>
            </div>
          </ng-template>
        </ion-popover>
      </div>

      <ion-item class="form-item" lines="none" *ngIf="mostrarCampoDescripcionEmergencia()">
        <ion-label position="stacked">Descripción de la emergencia</ion-label>
        <ion-textarea formControlName="descripcion_emergencia"
          placeholder="Indique brevemente el motivo de la emergencia" rows="3"></ion-textarea>
      </ion-item>
      </form>
  </div>

  <!-- Footer con botones (mismo lugar que el original: fuera del scroll) -->
  <div class="formulario-footer">
    <ion-button fill="outline" (click)="cerrar()" [disabled]="guardando">Cancelar</ion-button>
    <ion-button (click)="guardar()" [disabled]="guardando || !esFormularioValido()">
      <ion-icon slot="start" name="paper-plane-outline"></ion-icon>
      {{ guardando ? 'Guardando…' : 'Agendar' }}
    </ion-button>
  </div>
</div>

